export const META = {
  home: {
    title: "ATA Forge | Web Design for North Jersey Small Businesses",
    description:
      "Fast, modern websites for small businesses in Wayne, NJ and about 30 miles around. Free mockup, fixed prices, and live in 7–10 days.",
  },
  work: {
    title: "Concept Website Redesigns for Local Businesses | ATA Forge",
    description:
      "See how ATA Forge would redesign sites for a North Jersey HVAC and plumbing company, an auto shop, and a barber. Concept mockups, fictional businesses.",
  },
  services: {
    title: "Website Packages, Care Plans & Automation | ATA Forge",
    description:
      "Starter, Standard, and Growth website packages, monthly care plans, and automation add-ons for North Jersey small businesses. Fixed pricing, quoted up front.",
  },
  about: {
    title: "About ATA Forge | Local Web Design Studio in Wayne, NJ",
    description:
      "ATA Forge is three local founders in Wayne, NJ who bring a design and architecture background to fast, modern websites for businesses within about 30 miles.",
  },
  contact: {
    title: "Contact ATA Forge | Get a Free Website Mockup in Wayne, NJ",
    description:
      "Tell us about your business and get a free website mockup. Email info@ataforge.net. Serving Wayne, NJ and businesses within about 30 miles.",
  },
  notFound: {
    title: "Page Not Found | ATA Forge",
    description: "This page doesn't exist. Head back to ATA Forge for fast, modern websites for North Jersey small businesses.",
  },
};
